// extracted by mini-css-extract-plugin
export default {"shareArticle__link":"style_shareArticle__link__LoDxo","shareArticle__pinterest":"style_shareArticle__pinterest__2ND7W"};